var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _vm.personalInfoList && _vm.personalInfoList.uid ? _c('section', {
    staticClass: "user-container"
  }, [_c('div', {
    staticClass: "user-slider"
  }, [_c('div', {
    staticClass: "swiper-container"
  }, [_c('div', {
    staticClass: "swiper-wrapper"
  }, _vm._l(_vm.personalInfoList.poster, function (item, index) {
    return _vm.personalInfoList.poster && _vm.personalInfoList.poster.length > 1 ? _c('div', {
      key: index,
      staticClass: "swiper-slide"
    }, [_c('img', {
      attrs: {
        "src": item.big_poster,
        "width": "100%"
      }
    })]) : _vm.personalInfoList.poster && _vm.personalInfoList.poster.length == 1 ? _c('div', {
      staticClass: "swiper-slide"
    }, [_c('img', {
      attrs: {
        "src": _vm.personalInfoList.poster[0].big_poster,
        "width": "100%"
      }
    })]) : _c('div', {
      staticClass: "swiper-slide"
    }, [_c('img', {
      attrs: {
        "width": "100%"
      }
    })]);
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "swiper-pagination"
  })]), _vm._v(" "), _c('ul', {
    staticClass: "user-bind"
  }, _vm._l(_vm.bindList, function (item, index) {
    return _c('li', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: item.bind_type && item.bind_type !== '104' && item.bind_type !== '108' && item.isshow === 1 && item.bind_status === 1,
        expression: "item.bind_type && item.bind_type !== '104' && item.bind_type !== '108' && item.isshow === 1 && item.bind_status === 1"
      }],
      key: index
    }, [item.bind_url ? _c('a', {
      staticClass: "user-bind-link",
      attrs: {
        "href": item.bind_url,
        "target": _vm.target
      }
    }, [_c('div', {
      staticClass: "user-bind-app",
      class: _vm.getBindName(item.bind_type)
    })]) : _vm._e()]);
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "user-info"
  }, [_vm.personalInfoList.big_face ? _c('div', {
    staticClass: "user-headimage ratate360",
    style: {
      backgroundImage: 'url(' + _vm.personalInfoList.big_face + ')'
    }
  }, [_c('div')]) : _c('div', {
    staticClass: "user-headimage ratate360"
  }, [_c('div')]), _vm._v(" "), _c('div', {
    staticClass: "user-detail"
  }, [_c('p', {
    staticClass: "user-name"
  }, [_c('span', {
    staticClass: "username"
  }, [_vm._v(_vm._s(_vm.personalInfoList.nickname))]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.personalInfoList.ship == 0 && !_vm.isSelf,
      expression: "personalInfoList.ship == 0 && !isSelf"
    }],
    staticClass: "user-follow",
    on: {
      "click": function click($event) {
        return _vm.clickFollowFriend(_vm.personalInfoList.uid, 'personal', '0');
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("Follow")))]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.personalInfoList.ship != 0 && !_vm.isSelf,
      expression: "personalInfoList.ship != 0 && !isSelf"
    }],
    staticClass: "user-follow following"
  }, [_vm._v(_vm._s(_vm.$t("Following")))])]), _vm._v(" "), _c('p', {
    staticClass: "user-relation"
  }, [_c('a', {
    staticClass: "user-fans",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function click($event) {
        return _vm.clickShowPop('fansPop');
      }
    }
  }, [_c('span', {
    staticClass: "user-fans-num"
  }, [_vm._v(_vm._s(_vm.personalInfoList.follower_count))]), _vm._v(" "), _c('span', {
    staticClass: "user-fans-text"
  }, [_vm._v(_vm._s(_vm.$t("Fans")))])]), _vm._v(" "), _c('a', {
    staticClass: "user-following",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function click($event) {
        return _vm.clickShowPop('followPop');
      }
    }
  }, [_c('span', {
    staticClass: "user-following-num"
  }, [_vm._v(_vm._s(_vm.personalInfoList.following_count))]), _vm._v(" "), _c('span', {
    staticClass: "user-following-text"
  }, [_vm._v(_vm._s(_vm.$t("Following")))])])]), _vm._v(" "), _c('p', {
    staticClass: "usign",
    attrs: {
      "title": _vm.personalInfoList.usign
    }
  }, [_vm._v(_vm._s(_vm.personalInfoList.usign))]), _vm._v(" "), _c('p', {
    staticClass: "user-tag"
  }, [_vm.personalInfoList.addr ? _c('span', {
    staticClass: "user-addr"
  }, [_vm._v(_vm._s(_vm.personalInfoList.addr))]) : _vm._e(), _vm._v(" "), _c('span', {
    class: _vm.getSexClassName(_vm.personalInfoList.sex)
  }, [_vm._v("占位")]), _vm._v(" "), _vm._l(_vm.personalInfoList.impression, function (item, index) {
    return _c('span', {
      key: index,
      staticClass: "impression",
      style: {
        backgroundColor: _vm.getTagBgcolor(item)
      }
    }, [_vm._v(_vm._s(item.tag_name))]);
  })], 2)])])]) : _vm._e();
};
var staticRenderFns = [];
export { render, staticRenderFns };